import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = {
  minHeight: "100dvh",
  display: "flex",
  flexDirection: "column",
  bgcolor: "background.default",
  color: "text.primary",
};

export const main: SxProps<Theme> = {
  flex: 1,
  display: "flex",
  justifyContent: "center",
  px: { xs: 1.75, md: 3 },
  py: { xs: 3, md: 5 },
  pb: { xs: 6.25, md: 8.75 },
};

export const grid: SxProps<Theme> = {
  width: "100%",
  maxWidth: 1220,
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "1.5fr 1fr" },
  gap: { xs: 2.75, md: 3.5 },
  alignItems: "start",
};

export const formColumn: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: { xs: 2.75, md: 3 },
};

export const pageHeading: SxProps<Theme> = {
  display: { xs: "none", md: "flex" },
  flexDirection: "column",
  gap: 1,
};

export const pageTitle: SxProps<Theme> = { fontWeight: 700, fontSize: "1.6875rem", lineHeight: 1.3 };
export const pageSubtitle: SxProps<Theme> = { fontSize: ".875rem", color: "text.secondary", lineHeight: 1.7 };

export const wizardCard: SxProps<Theme> = (theme) => ({
  bgcolor: "background.paper",
  border: 1,
  borderColor: "divider",
  borderRadius: 3,
  boxShadow: theme.shadows[3],
  p: { xs: 2.75, md: 4.25 },
  display: "flex",
  flexDirection: "column",
  gap: { xs: 2.75, md: 3.25 },
  minHeight: { md: 480 },
});

export const navigation: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  borderTop: 1,
  borderColor: "divider",
  pt: 2.5,
  mt: "auto",
};
